module.exports = __webpack_public_path__ + "static/media/logo.13df3f06.png";